<template>
  <div>
    <div class="list-card_round task col-3 project-contents">
      <!-- <draggable
        :list="myProjectList"
        :disabled="!enabled"
        class="list-card_round task col-3"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
    > -->
      <a
        class="list-group-item"
        v-for="element in projectList"
        :id="element.projectId"
        :key="element.projectId"
        v-bind:href="element.link"
        v-bind:class="element.add_task"
      >
        <div class="list-top clear" > 
          <div v-show="tenantId !='418502'" :class="{
                'ico-evaluate-good': element.status == 'GOOD',
                'ico-evaluate-so': element.status == 'SO',
                'ico-evaluate-delay': element.status == 'DELAY',
                'ico-evaluate-exceeded': element.status == 'EXCEEDED',
              }"></div>
          <!-- <div class="ico-evaluate-so" v-if="element.status === 'SO'"></div>
          <div
            class="ico-evaluate-delay"
            v-if="element.status === 'DELAY'"
          ></div>
          <div
            class="ico-evaluate-exceeded"
            v-if="element.status === 'EXCEEDED'"
          ></div> -->
          <div class="btn_top hover fr">
            <button
              type="button"
              :class="{ active: element.favoriteYn == 1 ? 'active' : '' }"
              class="ico-switch_favorites"
              @click="
                registProjectFavorites(
                  element,
                  element.projectId,
                  element.favoriteYn,
                  $event
                )
              "
            >
              즐겨찾기
            </button>
          </div>
        </div>
        <!-- <router-link :to="`/general/dashboard/${element.projectId}`"> -->
        <router-link
          :to="{ name: 'dashboard', params: { projectId: element.projectId } }"
        >
          <div class="list-tit-m ell-multiline2 multi-ellipsis no-ellipsis" :class="element.projectId"
            @mouseover="mouseEvt(true, element, $event)"
            @mouseleave="mouseEvt(false, element, $event)"
          >
            {{ element.projectName }}
          </div>
          <div class="tooltip-b tl small" style="z-index: 11; display: none;" :id="element.projectId+'_tooltip'">
            <!-- tooltip -->
            {{ element.projectName }}
          </div>

        </router-link>
        <div class="list-btm clear">
          <div class="list-team fl">
            <!-- 의견 팝업형 -->
            <button type="button" class="ico-txt_comment" @click="openCommentModal(element)">
              <span
                :class="unReadComment.indexOf(element.projectId) != -1 ? 'ico-new' : ''">
              </span>
            </button>
            <!-- /의견 팝업형 -->
            <!-- 의견 레이어형 -->
            <!-- <div class="comment dropdown">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="getMemberlist($event, element)">
                    <div class="ico-txt_comment">
                      <span
                        :class="unReadComment.indexOf(element.projectId) != -1 ? 'ico-new' : ''">
                      </span>
                    </div>
                  </v-btn>
                </template>
                <div class="dropdown-list">
                  <ProjectComment
                    :callFrom="'projectContents'"
                    :projectId="element.projectId"
                    :groupId="element.groupId"
                    :userId="loginUserId"
                    :memberList="tmpData.commentMemberList"
                  />
                </div>
              </v-menu>
            </div> -->
            <!-- /의견 레이어형 -->
            <!-- <div class="dropdown ty1 small relative right">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class=""
                    @click="getProjectOkrLink(element.projectId)"
                    ><span class="ico-okr"></span
                    ><b>OKR {{ element.okrLinkCount }}</b></v-btn
                  >
                </template>
                <div class="dropdown-list">
                  <div class="okr-link-box">
                    <button
                      type="button"
                      class="btn_link_add"
                      @click="LinkedOkrPopup(element)"
                    >
                      OKR 링크 추가
                    </button>
                    <div class="scroll">
                      <dl>
                        <dt>나의 OKR</dt>
                        <dd>
                          <ul>
                            <li
                              v-for="(item, index) in okrLinkList"
                              :key="'myOkr' + index"
                            >
                              <div
                                class="row1"
                                v-if="item.regUserId == loginUserId"
                              >
                                <div class="label-fin">
                                  {{ ChangeOkrType(item.okrType) }}
                                </div>
                                <div class="name">{{ item.regUserName }}</div>
                                <button
                                  type="button"
                                  class="btn_link_release"
                                  @click="
                                    OkrDisconnection(
                                      element.projectId,
                                      item.projectOkrLinkId
                                    )
                                  "
                                >
                                  연결해제
                                </button>
                              </div>
                              <div
                                class="row2"
                                v-if="item.regUserId == loginUserId"
                              >
                                <b>{{ item.okrTitle }}</b>
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                      <dl>
                        <dt>다른 사람의 OKR</dt>
                        <dd>
                          <ul>
                            <li
                              v-for="(item, index) in okrLinkList"
                              :key="'okr' + index"
                            >
                              <div
                                class="row1"
                                v-if="item.regUserId != loginUserId"
                              >
                                <div class="label-fin">
                                  {{ ChangeOkrType(item.okrType) }}
                                </div>
                                <div class="name">{{ item.regUserName }}</div>
                              </div>
                              <div
                                class="row2"
                                v-if="item.regUserId != loginUserId"
                              >
                                <b>{{ item.okrTitle }}</b>
                              </div>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div> -->
            <!-- OKR연결 기능 재검토 아래 로직 주석 처리 (2021.03.11 leehc) -->
            <!--
            <button
              type="button"
              class="link-okr"
              @click="okrListPopup(element)"
            >
              OKR <span>{{ element.okrLinkCount }}</span>
            </button>
            -->
          </div>
          <div class="list-date fr">
            <span class="ico-new" v-if="element.lastUpdStatus === 1"></span>
            {{ $moment(element.lastProUpdDate).format("YYYY.MM.DD")}}
          </div>
        </div>
      </a>
      <!-- </draggable> -->
    </div>
    <!-- <div class="btn_more_box" v-if="count > 0">
        <button type="button" class="btn-more-ico_small1 down" @click="loadMoreProject">{{count}}건 더보기</button>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import OkrListPopup from "@/components/cowork/general/project/modal/OkrListPopup";
import ProjectCommentModal from "../modal/ProjectCommentModal";
import ProjectComment from "@/components/cowork/general/project/modal/ProjectComment";
export default {
  components: {
    ProjectComment,  
  },
  props: {
    projectList: {
      type: Array,
      required: true,
    },
    loginUserId: String,
    unReadComment: Array,
  },
  data() {
    return {
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      enabled: true,
      testVal: 15,
      list: [],
      count: null,
      myProjectList: [],
      myProjectCount: null,
      tmpData: {
        commentMemberList: [],
      },
    };
  },
  methods: {
    /* REST-API */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 즐겨찾기 목록 갱신 */
    ...mapMutations("project", ["setProjectFavoriteList"]),
    /* 모달 팝업 */
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),

    /* 말줄임(...) 시, tooltip 적용 */
    mouseEvt(flag, element, event) {
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = this.$tooltip.hasOverflownHeight(event.target);

        if(val) {
          document.getElementById(element.projectId+'_tooltip').style.display = 'block';
        }else{
          document.getElementById(element.projectId+'_tooltip').style.display = 'none';
        };
      }else{
        document.getElementById(element.projectId+'_tooltip').style.display = 'none';
      }
    },

    /* 즐겨찾기 등록(favoriteYn : 0이면 즐겨찾기 해제, 1이면 즐겨찾기 등록) */
    registProjectFavorites(project, projectId, favoriteYn, event) {
      let obj = this;
      let reqData = {
        method: "post",
        params: { projectId: projectId },
      };
      if (favoriteYn == 0) {
        /* 즐겨찾기 등록 */
        reqData.url = "/api/cogroup/project/registProjectFavorites";
      } else {
        /* 즐겨찾기 해제 */
        reqData.url = "/api/cogroup/project/deleteProjectFavorites";
      }
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            //event.target.classList.toggle("active");
            if(res.result !== null) {
              // list.forEach(item => {
              //   if(item.projectId === projectId) {
              //     project.favoriteYn = item.favoriteYn;
              //     event.target.classList.toggle("active");
              //   }
              // });
              // if(favoriteYn == 0) {
              //   project.favoriteYn = 1;
              // } else {
              //   project.favoriteYn = 0;
              // }
              obj.$emit("getMyProjectList");
            }
            //                    obj.getMyProjectList();
            //obj.setProjectFavoriteList(res.result);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    okrListPopup(element) {
      console.log(element);
      const modalInfo = {
        title: this.$i18nUtil.trans("entity.todo","할 일"),
        width: "800px",
        height: "617px",
        obj: this.$modal,
        projectId: element.projectId,
        projectName: element.projectName,
        publicYn: element.publicYn.toString(),
        startDate: element.startDate,
        endDate: element.endDate,
        component: OkrListPopup,
      };
      this.showModal(modalInfo);
    },
    openCommentModal(project) {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ProjectCommentModal.001","과제 의견"),
        name: "ProjectCommentModal",
        method: "post",
        width: "340px",
        obj: this.$modal,
        component: ProjectCommentModal,
        param: {
          projectId: project.projectId,
          groupId: project.groupId,
          userId: this.loginUserId,
          unReadComment: this.unReadComment,
        },
      };
      this.showModal(modalInfo);
    },
    /* 멤버  */
    getMemberlist(e, project) {
      let self = this;
      let reqData = {};
      reqData.req = {
        groupId: project.groupId,
      };
      let memberList = self.tmpData.commentMemberList;
      memberList.splice(0, self.tmpData.commentMemberList.length);
      reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
      reqData.method = "post";
      self
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          console.log(res);
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if (res.result && res.result.data) {
              res.result.data.forEach(item => {
                memberList.push(item);
              });
            }
            let inx = self.unReadComment.indexOf(project.projectId);
            if (inx != -1) {
              self.unReadComment.splice(inx, 1);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 말줄임 */
    multiElipsis(ellipsisLine, projectId) {
      let selecter = "multi-ellipsis " + projectId;
      var omle = document.getElementsByClassName(selecter);
      for(let item of omle){
        // console.log(projectId, item.scrollHeight);
        if (item.scrollHeight > 70) {
            item.classList.remove("no-ellipsis");
        } 
      } 
    },
  },
  mounted() {
    this.projectList.forEach(item => {
      this.multiElipsis(2, item.projectId)
    })
  }
};
</script>

<style scoped>
  .multi-ellipsis {
    overflow: hidden;
    position: relative;
    line-height: 1.44;
    text-align: justify;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
  }
  .multi-ellipsis:before,
  .multi-ellipsis:after {
    content: "...";
    line-height: 1;
    position: absolute;
    right: 0;
    top: 1.44em;
    -ms-wrap-flow: start;
  }
  .multi-ellipsis:after {
    background: currentColor !important;
    color: #fff !important;
    top: auto;
  }
  .multi-ellipsis.no-ellipsis::before,
  .multi-ellipsis.no-ellipsis::after {
    display: none;
  }
  @supports (-webkit-line-clamp: 2) {
    .multi-ellipsis {
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .multi-ellipsis::before,
    .multi-ellipsis::after {
      content: normal;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/base/ProjectContents.vue